export default "__VITE_ASSET__DNSRb72s__"